import {useEffect, useMemo} from 'react';
import {useMap, useMapsLibrary} from '@vis.gl/react-google-maps';
import {FeatureCollection, Point, GeoJsonProperties} from 'geojson';

type HeatmapProps = {
  geojson: any;
  radius: number;
  opacity: number;
};
export const Heatmap = ({geojson, radius, opacity}: HeatmapProps) => {
  const map = useMap();
  const visualization = useMapsLibrary('visualization');

  const heatmap = useMemo(() => {
    if (!visualization) return null;

    return new google.maps.visualization.HeatmapLayer({
      radius: radius,
      opacity: opacity
    });
  }, [visualization, radius, opacity]);

  useEffect(() => {
    if (!heatmap) return;

    heatmap.setData(
      geojson.features.map((point: any) => {
        const [lng, lat] = point.geometry.coordinates;

        return {
          location: new google.maps.LatLng(lat, lng),
          weight: point.properties?.mag
        };
      })
    );
  }, [heatmap, geojson, radius, opacity]);

  useEffect(() => {
    if (!heatmap) return;

    heatmap.setMap(map);

    return () => {
      heatmap.setMap(null);
    };
  }, [heatmap, map]);

  return null;
};
